export function mapPageViewModelToPageUpdate(pageViewModel) {
    return {
        ContentId: pageViewModel.PageAssetId,
        Title: pageViewModel.PageTitle
    };
}
